import { Card } from "./card";

interface AlertCardSkeletonProps {
  count?: number;
}

export const AlertCardSkeleton: React.FC<AlertCardSkeletonProps> = ({ count = 4 }) => {
  return (
    <div className="animate-pulse flex w-full gap-1.5 sm:gap-3 py-1.5 sm:py-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="flex-1 min-w-0 w-full">
          <Card className="rounded-lg shadow-sm border border-gray-200 h-[80px] sm:h-[103px] bg-white/80">
            <div className="p-2.5 h-full flex flex-col justify-center items-center space-y-2">
              <div className="h-4 bg-gray-200 rounded w-8"></div>
              <div className="h-3 bg-gray-200 rounded w-16"></div>
            </div>
          </Card>
        </div>
      ))}
    </div>
  );
};